import styled from 'styled-components';

export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
`;

export const ContentDiv = styled.div`
	height: 100%;
	overflow: hidden;
`;
